import { FC } from "react";
import useEvent from "react-use-event-hook";

import { SVG_MUI } from "@ryde/assets";
import { CHECKBOX_DEFAULT_SIZE } from "@ryde/shared";

import { CheckboxMuiContainerStyled } from "./checkboxes.styled";

interface ICheckboxMuiProps {
  checked: boolean;
  width?: number;
  height?: number;
  grayStyleChecked?: boolean;
  onCheckboxToggle?: () => void;
}

export const CheckboxMui: FC<ICheckboxMuiProps> = ({
  checked,
  width = CHECKBOX_DEFAULT_SIZE,
  height = CHECKBOX_DEFAULT_SIZE,
  grayStyleChecked = false,
  onCheckboxToggle,
}) => {
  const toggleChecked = useEvent((): void => {
    onCheckboxToggle?.();
  });

  return (
    <CheckboxMuiContainerStyled
      data-e2e-value={checked ? "checked" : "unchecked"}
    >
      {!checked && (
        <SVG_MUI.CheckboxUncheckedSVG
          onClick={toggleChecked}
          width={width}
          height={height}
          data-e2e="svg-unchecked-mui"
        />
      )}
      {checked && !!grayStyleChecked && (
        <SVG_MUI.CheckboxCheckedSVG
          onClick={toggleChecked}
          width={width}
          height={height}
          data-e2e="svg-checked-mui"
        />
      )}
      {checked && !grayStyleChecked && (
        <SVG_MUI.CheckboxCheckedBlueSVG
          onClick={toggleChecked}
          width={width}
          height={height}
          data-e2e="svg-checked-mui-blue"
        />
      )}
    </CheckboxMuiContainerStyled>
  );
};
